import { render } from "./Contact.vue?vue&type=template&id=35b22188&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "../assets/css/find.css?vue&type=style&index=0&id=35b22188&scoped=true&lang=css&external"
import "../assets/css/contact.css?vue&type=style&index=1&id=35b22188&scoped=true&lang=css&external"
import "./Contact.vue?vue&type=style&index=2&id=35b22188&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b22188"]])

export default __exports__